import { FilterOption } from "../../../../models";
import { RequestFilterModelType } from "../../../../services";
import {
  PDLAccordionItem,
  PDLAccordionItemBody,
  PDLAccordionItemHeader,
} from "../../dna";
import FiltroOpcoes from "../_filtroOpcoes";
import PeriodSelector from "../_periodSelector";

interface FiltrosItemProps {
  id: string | null;
  type?: string | null;
  index: number;
  title: React.ReactNode;
  options: FilterOption[];
  padding?: boolean;
  onPeriodChange?: (value: any) => void;
  period?: any;
  isModelTypeFilterItem?: boolean;
  modelType?: RequestFilterModelType | undefined;
}

const FiltrosItem = ({
  id = null,
  type = null,
  index = 0,
  title = null,
  options = [],
  padding = false,
  onPeriodChange,
  period,
  isModelTypeFilterItem = false,
  modelType,
}: FiltrosItemProps) => {
  return (
    <PDLAccordionItem key={`filtros-item-${index}`} eventKey={index.toString()}>
      <PDLAccordionItemHeader>{title}</PDLAccordionItemHeader>

      <PDLAccordionItemBody className={padding ? "ps-3 pe-0 py-0" : "p-0"}>
        <FiltroOpcoes
          id={id ?? ""}
          options={options}
          isModelTypeFilterItem={isModelTypeFilterItem}
          modelType={modelType}
        />

        {type === "date" && onPeriodChange && period && (
          <PeriodSelector onPeriodChange={onPeriodChange} period={period} />
        )}
      </PDLAccordionItemBody>
    </PDLAccordionItem>
  );
};

export default FiltrosItem;
